const { createSlice } = require("@reduxjs/toolkit");

const modalSlice = createSlice({
    name: 'modal',
    initialState: {
        isOpened: false,
    },
    reducers: {
        openModal: (state) =>{
            state.isOpened = true
        }, 
        closeModal: (state) => {
            state.isOpened = false
        }
    }
})

export const {openModal, closeModal} = modalSlice.actions
export default modalSlice.reducer